<a class="post-network-projects__post" [href]="item.link" target="_blank" *ngFor="let item of data">
  <img class="post-network-projects__image" loading="lazy" [src]="item.image" [alt]="item.titulo" />
  <div class="post-network-projects__info">
    <p>{{ item.title }}</p>
    <span>{{ item.description }}</span>
  </div>
</a>
